var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "selectChevron_svg__MuiSvgIcon-root",
    viewBox: "0 0 24 12",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12 12L24 0z"
  })));
}
export default SvgSelectChevron;